import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as _ from "lodash";

import { Service } from "../service.class";
import { ClientModel } from "../../../shared/entities/client.model";
import { PurchasedPackModel } from "../../../shared/entities/purchased-pack.model";

@Injectable({
	providedIn: "root",
})
export class ClientModelService {
	constructor(private service: Service) {}

	private server_clients_path: string = "/v2/clients";
	private server_purchases_path: string = "/v2/purchasedPacks";
	private server_sales_path: string = "/v2/sales"

	// GET METHODS

	public getAdminClientActiveProducts(clientId?: string): Observable<{ data: PurchasedPackModel[] }> {
		const params = {};
		if (clientId) {
			_.set(params, "client", clientId);
			_.set(params, "paginate", false);
		}
		return this.service.apiGetWithoutHeaders(this.server_purchases_path, params);
	}

	public cancelPurchasedPack(id?: string): Observable<any> {
		return this.service.apiPut(this.server_purchases_path + "/cancel/" + id, {});
	}

	public cancelReNewPurchasedPack(clientId?: string, renew?: boolean): Observable<any> {
		const params = { renew: renew };
		return this.service.apiPut(this.server_purchases_path + "/" + clientId, params);
	}

	public cancelAutoRenewalPurchasedPack(clientId?: string, renew?: boolean): Observable<any> {
		const params = { renew: renew };
		return this.service.apiPut(this.server_purchases_path + "/renewal/" + clientId, params);
	}

	public cancelPaidSale(saleId?: string, paid?: boolean): Observable<any> {
		const body = { paid: paid };
		return this.service.apiPostWithoutHeaders(this.server_sales_path + "/" + saleId + "/pay", body);
	}

	public cancelTransaction(orderId: string): Observable<unknown> {
		return this.service.apiDelete(this.server_purchases_path + "/transaction/" + orderId);
	}

	public cancelLicense(purchasedPack_id: string): Observable<unknown> {
		return this.service.apiDelete(this.server_purchases_path + "/cancel/license/" + purchasedPack_id);
	}

	public markAsPaid(client_id?: string, body?: { orderId: string }): Observable<any> {
		return this.service.apiPut(this.server_clients_path + "/payments/finish/" + client_id + "/transfer", body);
	}

	public generateBill(clientId?: string, object?: any): Observable<any> {
		return this.service.apiPut(this.server_clients_path + "/payments/finish/transfer/" + clientId, object);
	}

	// GET METHOD BY ID
	public getAdminClientModelById(clientId: any): Observable<ClientModel> {
		return this.service.apiGetWithHeaders(this.server_clients_path + "/" + clientId, {});
	}

	public getTaxValue(id: string): Observable<{ taxValue: number }> {
		return this.service.apiGetWithHeaders(`${this.server_clients_path}/erp/data/tax?id=${id}`, {});
	}
}
